<template>
    <div class="CDotCounter">
        <CTransitionScale>
            <div
                v-if="count"
                class="flex size-5 items-center justify-center rounded-full bg-red-400 text-xs font-semibold text-white"
            >
                {{ count || 1 }}
            </div>
        </CTransitionScale>
    </div>
</template>

<script setup lang="ts">
import CTransitionScale from '@/components/ui/transitions/CTransitionScale.vue'

interface Props {
    count?: number
}

withDefaults(defineProps<Props>(), {
    count: 0
})
</script>
